import * as React from "react";
function SvgBubbleRetweet(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M1 19v-4a3.81 3.81 0 014-4h7M11 9l2 2M11 13l2-2M15 15v4a3.81 3.81 0 01-4 4H3M5 25l-2-2M5 21l-2 2"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M1 5a2 2 0 012-2h26a2 2 0 012 2v16a2 2 0 01-2 2h-4v6l-6-6M1 5v2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleRetweet);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
